import img from "../media/undraw_interview_yz52 (1).svg"
import Footer from "../components/footer";
import "../css/screening.css"
import Navbar from "../components/nav";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import useStore from "../store/zustandstore";
import { db } from "../firebase/firebase";
import { useEffect } from "react";
import logo1 from "../media/whiteFav.png";
import { Icon } from "@iconify/react";
import usefbStore from "../store/firebasestore";
import { doc,updateDoc,getDocs,collection } from "firebase/firestore";

function Referral(){


    const navigate = useNavigate()
    const userID = usefbStore((s)=>s.userID)
    const setScreenCount =usefbStore((s)=>s.setScreenCount)
    const screenCount = usefbStore((s)=>s.screenCount)
    const hideScreenLoader= useStore((s)=>s.hideScreenLoader)
     const closeFonMenu = useStore((s)=> s.closeFonMenu)
  const fonMenuDrawer = useStore((s)=> s.fonMenuDrawer)
 
 
     const cnclFon = () =>{
    closeFonMenu();
  }

   const toAuth=()=>{

      navigate("/auth")
    }
     

   return (

    <section className="preScreen">
                <Helmet>
  <title>Referral Program | Solara</title>
  <meta
    name="description"
    content="Invite others to Solara and participate in our referral program."
  />  
        </Helmet>
        <div className={`fonMenu ${fonMenuDrawer ? "fonMenuActive" : ""}`} >
        <img src={logo1} alt="" />
        <div className="sideMenuPlacer">
          <div className="fonMenuX" onClick={cnclFon}>
                
                <Icon className="faIcon" icon="solar:alt-arrow-right-linear" />
          </div>
        <div className="fonMenuLinks">

             <a href="/jobs">Job Opportunities</a>
             <a href="/dashboard">AI Tasks</a>
             <a href="/referral-program">Referral Program</a>
             <a href="/about">About Us</a>
            <button onClick={()=>toAuth()}>Get Started</button>
          </div>
          
        </div>
      </div>
        <div className="navContWhite navContWhiteLg">
                    <Navbar />
        </div>
        <div className="preScrenCont">
       <div className="preScreenImg">
             <h2>Referral Program</h2>
        </div>
        <div className="preScreenCont">
            <h3>Invite a Friend.</h3>
<p>
We’re excited to announce that Solara’s Referral Program is on the way. Soon, you’ll be able to invite friends, colleagues, and fellow freelancers to join Solara and earn rewards as they get started on their remote work journey. Our goal is to make Solara not just a platform for work, but a growing ecosystem where everyone benefits from sharing opportunities.
</p>

<p>
With the Referral Program, you can expect to earn rewards for every successful referral, grow your network within the Solara community, and unlock additional earning opportunities. Stay tuned — the Referral Program will be launching soon. Want early access? Keep an eye on your dashboard for updates.
</p>



        </div>

        </div>
 

      <Footer/>
        

    </section>
   )
}

export default Referral;